import { render, staticRenderFns } from "./VirtualShopUpgradeTip.vue?vue&type=template&id=0bd5d803&scoped=true"
import script from "./VirtualShopUpgradeTip.vue?vue&type=script&lang=ts"
export * from "./VirtualShopUpgradeTip.vue?vue&type=script&lang=ts"
import style0 from "./VirtualShopUpgradeTip.vue?vue&type=style&index=0&id=0bd5d803&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd5d803",
  null
  
)

export default component.exports